package it.neckar.lizergy.model.configuration.moduleLayout.planning

import com.meistercharts.charts.pv.roofPlanning.ModuleArea
import com.meistercharts.charts.pv.roofPlanning.ModuleArea.ModuleAreaId
import com.meistercharts.charts.pv.roofPlanning.ModuleOrientation
import com.meistercharts.charts.pv.roofPlanning.RoofRelative
import it.neckar.geometry.Coordinates
import it.neckar.geometry.Size
import it.neckar.open.unit.si.mm
import it.neckar.uuid.HasUuid
import kotlinx.serialization.Serializable
import kotlin.uuid.Uuid

/**
 * The placement information for a single module area
 */
@Serializable
data class ModuleAreaInformation(
  val id: ModuleAreaId,
  /**
   * The location of the module area (bottom left corner of the roof)
   */
  val location: @RoofRelative Coordinates,
  /**
   * The size of the module area
   */
  val size: @mm Size,
  /**
   * The module orientation
   */
  val orientation: ModuleOrientation,
  /**
   * The horizontal/vertical gap between modules
   */
  val gap: @mm Double,
  /**
   * The information for each module for this module area
   */
  val modulesInformation: ModulesInformation,
) : HasUuid {

  override val uuid: Uuid
    get() = id.uuid
}


fun ModuleArea.toRestApiModel(): ModuleAreaInformation {
  return ModuleAreaInformation(
    id = this.id,
    location = this.location,
    size = this.size,
    orientation = this.moduleOrientation,
    gap = this.gap,
    modulesInformation = this.modules.toRestApiModel()
  )
}
